/**
 * Created by lari on 08/06/2017.
 */
(function () {
  'use strict';
  angular.module('vcfinance.privcat')
    .component('privcatentryform', {
      restrict: 'E',
      bindings: {
        privcatentry: '<',
        parentsave: '&',
        oncancel: '&'
      },
      templateUrl: 'vcfinance/privcat/privcatentryform-component.tpl.html',
      controllerAs: 'vm',
      controller: ['$log',
        function ($log) {
          let vm = this;
          vm.save = save;
          vm.cancel = cancel;
          vm.normPrice = normPrice;
          // vm.zipsave = zipsave;

          vm.$onInit = function () {
            vm.lastprivcatentry = angular.copy(vm.privcatentry);
          };

          function save() {
            vm.lastprivcatentry = angular.copy(vm.privcatentry);
            vm.parentsave({privcat: vm.privcatentry});
/*            if (!angular.equals(vm.privcatentry, vm.lastprivcatentry)) {
              vm.lastprivcatentry = angular.copy(vm.privcatentry);
              vm.parentsave({privcat: vm.privcatentry});
            }*/
          }

          function cancel() {
            vm.privcatentry = angular.copy(vm.lastprivcatentry);
            vm.oncancel();
          }

          // turn user entry into units of one/tenth of cents
          function normPrice() {
            if (angular.isDefined(vm.privcatentry.priceuserentry) && angular.isNumber(vm.privcatentry.priceuserentry)) {
              vm.privcatentry.normprice = parseInt(vm.privcatentry.priceuserentry * 1000, 10);
              vm.privcatentry.price = parseFloat(vm.privcatentry.price);
            }
          }


        }] // controller
    }); // component

// klammerfriedhof
}());